import { GONDOLA } from "../../consts/colors";

export const styles = {
  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px 16px",
    borderRadius: "6px",
    maxWidth: "200px",
    height: "46px",
    cursor: "pointer",
  },

  filterText: {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    letterSpacing: "0px",
    textAlign: "left",
    color: GONDOLA,
  },

  drawerContainer: {
    width: 350,
    p: 4,
  },

  drawerTitle: {
    mb: 3,
    fontWeight: 700,
  },

  filterSection: {
    display: "block",
  },

  filterLabel: {
    mb: 1,
    display: "block",
    fontWeight: 600,
    fontSize: "0.875rem",
  },

  radioFilterLabel: {
    mb: 0.5,
    display: "block",
    fontWeight: 600,
    fontSize: "0.875rem",
  },

  actionRow: {
    mt: 2,
  },

  doneButton: {
    width: "100%",
    height: "40px",
  },
};

export const smallFieldStyles = {
  "& .MuiFormLabel-root": {
    fontSize: "0.875rem !important",
  },
  "& .MuiInputBase-input": {
    fontSize: "0.875rem !important",
  },
  "& .MuiSelect-select": {
    fontSize: "0.875rem !important",
  },
};
